import Query from "./Query";
import Ip from "./Ip";

const toolsList = {
    query: Query,
    ip: Ip
};

export default toolsList;